"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const v4_1 = __importDefault(require("uuid/v4"));
exports.loadSculptures = () => {
    try {
        let saved = [];
        for (let i = 0; i < localStorage.length; i++) {
            const key = localStorage.key(i);
            if (key && key.startsWith("sculpture_")) {
                saved.push(JSON.parse(localStorage.getItem(key)));
            }
        }
        return saved;
    }
    catch (ex) {
        console.error("Unable to load", ex);
        return [];
    }
};
exports.saveSculpture = (name, project) => {
    const dateISO = new Date().toISOString();
    const toSave = JSON.stringify({
        name,
        project,
        date: dateISO
    });
    window && window.localStorage.setItem("sculpture_" + v4_1.default(), toSave);
};



// WEBPACK FOOTER //
// ./src/data/localStore.ts